import system from "./theme";

export { system };
export default system;
